import React, { useState, useEffect } from "react";
const Pagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
}) => {
  const [jumpPage, setJumpPage] = useState(currentPage);
  useEffect(() => {
    setJumpPage(currentPage);
  }, [currentPage]);
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  if (totalPages <= 1) return null;
  const goPrev = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };
  const goNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };
  const handleJump = (e) => {
    e.preventDefault();
    const page = Number(jumpPage);
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };
  return (
    <div className="d-flex align-items-center justify-content-end">
      <button
        className="btn border-dark m-2"
        disabled={currentPage === 1}
        onClick={goPrev}
      >
        <i className="fe fe-chevron-left fs-5"></i>
      </button>
      <form onSubmit={handleJump}>
        <input
          type="number"
          min="1"
          max={totalPages}
          value={jumpPage}
          onChange={(e) => setJumpPage(e.target.value)}
          className="btn border-dark text-center"
          style={{ width: "60px" }}
        />
      </form>
      <button className="btn border-dark m-2">of {totalPages} pages</button>
      <button
        className="btn border-dark"
        disabled={currentPage === totalPages}
        onClick={goNext}
      >
        <i className="fe fe-chevron-right fs-5"></i>
      </button>
    </div>
  );
};
export default Pagination;
